

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CREATEEMPLOYEE= createAsyncThunk(
  "createEmployee/createEmployee",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createEmployeeSlice = createSlice({
  name: "createEmployeeSlice",
  initialState: {
    createEmployee: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateEmployee: (state) => {
        state.createEmployee.loading = false
        state.createEmployee.error = false
        state.createEmployee.data = []
        state.createEmployee.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEEMPLOYEE.fulfilled, (state, action) => {
      state.createEmployee = {
        ...state.createEmployee,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEEMPLOYEE.pending, (state, action) => {
      state.createEmployee = {
        ...state.createEmployee,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEEMPLOYEE.rejected, (state, action) => {
      state.createEmployee = {
        ...state.createEmployee,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createEmployeeAction = {
    CREATEEMPLOYEE,
};

export { createEmployeeAction };
export default createEmployeeSlice.reducer;
export const {setInitialStateOfcreateEmployee} = createEmployeeSlice.actions
